import * as rq from '@tanstack/react-query';

import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { useDependencies } from '../contexts/dependencies.context';

export namespace GetWarrantyPenaltyChartData {
  export const key = (input: Input, repository: IWarrantyRepository) => [
    'warranty',
    'get-warranty-penalty-chart-data',
    repository.key,
    input.filters,
    input.assetFullFrontendId,
  ];

  export type Params = { refetchInterval?: number };
  export type Input = IWarrantyRepository.GetWarrantyPenaltyChartDataInput;
  export type Output = IWarrantyRepository.GetWarrantyPenaltyChartDataOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input, repositories.warranty),
      queryFn: () => repositories.warranty.getWarrantyPenaltyChartData(input),
    });
  }
}
